export default __webpack_public_path__ + "static/media/close-icon.a0d18937.svg";